var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "project-modal edit-deliverable-modal edit-project-modal",
      class: !_vm.userCanEditProject ? "read-only" : "",
      attrs: { id: "edit__project__modal" }
    },
    [
      _c("div", { staticClass: "project--top--section" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-8 d-flex left--side" },
            [
              _c("div", { staticClass: "project--page--title" }, [
                _c("h2", { staticClass: "d-inline-block" }, [
                  _c(
                    "div",
                    {
                      staticClass: "project-icon bigger-icon pointer-default",
                      style: {
                        backgroundColor: _vm.getProjectColor(_vm.projectDetail)
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/csmworkflow/img/white-folder.svg")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text--section" }, [
                  _c(
                    "div",
                    { staticClass: "project--department--wrap" },
                    [
                      _c("ProjectDepartments", {
                        attrs: { deliverable: _vm.projectDetail }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "mb-0 w-100" }, [
                    _c(
                      "h1",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass:
                          "mb-0 exclude-outside-click edit-d-title project-title",
                        staticStyle: { "line-height": "1" },
                        on: { click: _vm.activateTitleField }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.projectDetail.title || "Click to set...")
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editTitle,
                          expression: "editTitle"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.projectDetail.title,
                          expression: "projectDetail.title"
                        }
                      ],
                      ref: "deliverableTitle",
                      staticClass:
                        "form-control mb-3 title-field exclude-outside-click h1",
                      attrs: { type: "text", placeholder: "Project title..." },
                      domProps: { value: _vm.projectDetail.title },
                      on: {
                        change: _vm.updateProjectTitle,
                        blur: function($event) {
                          _vm.editTitle = false
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.projectDetail,
                            "title",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "project-number" }, [
                    _c("span", [
                      _vm._v(
                        "Project Number: " +
                          _vm._s(_vm.projectDetail.project_number)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "project-due-date" }, [
                    _vm._v("\n            \tDeadline:\n              "),
                    _c(
                      "span",
                      {
                        ref: "refDatepickerWrapper",
                        staticClass: "editable-project-due-date",
                        on: { click: _vm.projectDueDateClick }
                      },
                      [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editProjectDueDateBg,
                              expression: "editProjectDueDateBg"
                            }
                          ],
                          staticClass: "custom-field-outside-bg-mobile"
                        }),
                        _vm._v(" "),
                        _c(
                          "vuejs-datepicker",
                          {
                            directives: [
                              {
                                name: "field-dismiss",
                                rawName: "v-field-dismiss",
                                value: _vm.editProjectDatePickerClickOutside,
                                expression: "editProjectDatePickerClickOutside"
                              }
                            ],
                            ref: "projectDueDate",
                            attrs: { placeholder: "No Date" },
                            on: {
                              input: _vm.updateProjectDueDate,
                              selected: _vm.projectDueDateSelected
                            },
                            nativeOn: {
                              focusin: function($event) {
                                return _vm.findPosition.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.projectDetail.due_date,
                              callback: function($$v) {
                                _vm.$set(_vm.projectDetail, "due_date", $$v)
                              },
                              expression: "projectDetail.due_date"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "calender-header",
                                attrs: { slot: "beforeCalendarHeader" },
                                slot: "beforeCalendarHeader"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "remove-dl-btn",
                                    attrs: { variant: "text" },
                                    on: { click: _vm.resetDeadline }
                                  },
                                  [_vm._v("Remove Deadline")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "today-btn",
                                    attrs: { variant: "text" },
                                    on: { click: _vm.onToday }
                                  },
                                  [_vm._v("Today")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.projectDeliverables.length
                ? _c("div", { staticClass: "project--milestones" }, [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v("PROJECT MILESTONES")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "project--milestones-wrap" },
                      _vm._l(_vm.projectDeliverables.length, function(index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  customClass: "milestone--tooltip",
                                  html: true,
                                  title: _vm.tipData(
                                    _vm.projectDeliverables[index - 1]
                                  ),
                                  trigger: "hover"
                                },
                                expression:
                                  "{ customClass: 'milestone--tooltip', html: true, title: tipData(projectDeliverables[index-1]), trigger: 'hover' }"
                              }
                            ],
                            staticClass: "milestone",
                            class: {
                              active:
                                _vm.projectDeliverables[index - 1]
                                  .is_complete == 1,
                              dots: index <= _vm.projectDeliverables.length
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "milestone--full--deliverable" },
                              [_vm._v(" ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "milestone--task--expanson" },
                              _vm._l(
                                _vm.projectDeliverables[index - 1].tasks.length,
                                function(index1) {
                                  return _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: {
                                            customClass: "milestone--tooltip",
                                            html: true,
                                            title: _vm.tipTaskData(
                                              _vm.projectDeliverables[index - 1]
                                                .tasks[index1 - 1]
                                            ),
                                            trigger: "hover",
                                            placement: "bottom"
                                          },
                                          expression:
                                            "{ customClass: 'milestone--tooltip', html: true, title: tipTaskData(projectDeliverables[index-1].tasks[index1-1]), trigger: 'hover', placement: 'bottom' }"
                                        }
                                      ],
                                      style: {
                                        backgroundColor: _vm.tryJSONParse(
                                          _vm.getFieldJson(
                                            _vm.projectDeliverables[index - 1]
                                              .tasks[index1 - 1].taskFields,
                                            "status"
                                          ).value
                                        ).color
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.scrollToTask(
                                            _vm.projectDeliverables[index - 1]
                                              .tasks[index1 - 1].id,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" ")]
                                  )
                                }
                              ),
                              0
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dates" }, [
                      _c("span", { staticClass: "left" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.projectDetail.start_date,
                              "MMMM DD, YYYY"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.projectDetail.due_date,
                              "MMMM DD, YYYY"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm._.filter(_vm.projectDetail.customFields, {
                  field_key: "project_detail"
                }),
                function(field, index) {
                  return _c(
                    "div",
                    {
                      key: "prj__detail__" + index,
                      staticClass: "field-box project--detail--field"
                    },
                    [
                      _c("ProjectCustomFields", {
                        attrs: {
                          deliverable: _vm.projectDetail,
                          customField: field
                        }
                      })
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c("div", { staticClass: "project--resources" }, [
                _c(
                  "div",
                  { staticClass: "dropdown project--resources--title" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "add-resource-button exclude-outside-click d-inline-block",
                        attrs: {
                          title: "Add resource",
                          id: "add-resource-button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false"
                        }
                      },
                      [_vm._v("Resources")]
                    ),
                    _vm._v(" "),
                    _c("plus-button", {
                      attrs: {
                        "data-toggle": "dropdown",
                        "aria-expanded": "false",
                        "data-reference": "parent"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu project--resources--type--menu"
                      },
                      _vm._l(_vm.optionsForLinkType, function(type, i) {
                        return _c(
                          "a",
                          {
                            key: i,
                            staticClass: "dropdown-item",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.addResourceMenuItemClick(
                                  type,
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "link-type-icon",
                              attrs: {
                                src: require("@/csmworkflow/img/" + type.icon)
                              }
                            }),
                            _vm._v(" " + _vm._s(type.name))
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.getProjectResourcesClass },
                  _vm._l(
                    _vm._.filter(_vm.projectDetail.customFields, {
                      field_key: "link_url"
                    }),
                    function(resource, index) {
                      return _vm.showResourceBox(
                        resource.value,
                        resource.pfv_id
                      )
                        ? _c(
                            "div",
                            {
                              key: "link_url-" + index,
                              staticClass: "resource-entry resource-box",
                              class: _vm.userCanEditProject
                                ? "editable"
                                : "not-editable"
                            },
                            [
                              _c("img", {
                                staticClass: "link-type-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/" +
                                    _vm.getLinkTypeObject(
                                      _vm.customChildFieldValue(
                                        "link_type",
                                        resource.pfv_id
                                      )
                                    ).icon),
                                  draggable: "false"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "resource-box__url" }),
                              _vm._v(" "),
                              resource.value
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "resource-link",
                                      attrs: {
                                        href: resource.value,
                                        target: "_blank",
                                        id: "project-resource-" + index
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openCopyLinkModal(
                                            resource.value,
                                            $event,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customChildFieldValue(
                                            "link_label",
                                            resource.pfv_id
                                          ) || resource.value
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !resource.value
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "resource-link",
                                      attrs: {
                                        href: _vm.getResourceHref(
                                          resource.value,
                                          resource.pfv_id
                                        ),
                                        target: "_blank",
                                        id: "project-resource-" + index
                                      },
                                      on: { click: _vm.setCookieForDownload }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customChildFieldValue(
                                            "link_label",
                                            resource.pfv_id
                                          ) || resource.value
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    target: "project-resource-" + index,
                                    noninteractive: "",
                                    triggers: "manual"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-check",
                                    staticStyle: {
                                      color: "'var(--wf-primary)'"
                                    }
                                  }),
                                  _vm._v(" Link Copied!")
                                ]
                              ),
                              _vm._v(" "),
                              _vm.userCanEditProject
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "edit-resource-btn",
                                      attrs: {
                                        title: "Edit resource",
                                        href: "#"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editResource(resource)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-edit" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customChildFieldValue(
                                "link_notes",
                                resource.pfv_id
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "resource-box__notes" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customChildFieldValue(
                                            "link_notes",
                                            resource.pfv_id
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    }
                  ),
                  0
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4 right--side" }, [
            _c(
              "div",
              { staticClass: "project-right-side-fields" },
              [
                typeof _vm.projectDetail == "object" &&
                _vm.projectDetail.engagement_manager &&
                _vm.getSystemSetting("project__show_engagement_manager")
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: {
                              field_key: "engagement_manager",
                              field_name: "engagement_manager",
                              label: "Engagement Manager"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.projectDetail == "object" &&
                _vm.projectDetail.project_lead
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: {
                              field_key: "project_lead",
                              field_name: "project_lead",
                              label:
                                _vm.getSystemSetting(
                                  "project__project_lead_label"
                                ) || "PROJECT LEAD"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_status"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_audience"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_secondary_audience"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "account_number"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "budget"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "requisition_number"
                  }),
                  function(field, index) {
                    return _vm.showProjectCustomField(
                      _vm.projectDetail,
                      "requisition_number"
                    )
                      ? _c(
                          "div",
                          {
                            key: "prj__requisition__number__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              key: "prjfields" + _vm.projectDetail.id,
                              attrs: {
                                deliverable: _vm.projectDetail,
                                customField: field
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "manager_marketing_branding"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "marketing_officer"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "communications_officer"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm.projectDetail.id
                  ? _c(
                      "b-tabs",
                      {
                        staticClass: "field-tabs",
                        attrs: {
                          "content-class": "field-tab-content",
                          fill: ""
                        },
                        model: {
                          value: _vm.currentTab,
                          callback: function($$v) {
                            _vm.currentTab = $$v
                          },
                          expression: "currentTab"
                        }
                      },
                      [
                        _vm.hasContactFields()
                          ? _c(
                              "b-tab",
                              {
                                staticClass: "field-tab-contacts field-box",
                                attrs: { active: "", title: "Contact" }
                              },
                              [
                                _c("ProjectContact", {
                                  attrs: { projectDetail: _vm.projectDetail }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSystemSetting("is_chat_enabled")
                          ? _c(
                              "b-tab",
                              {
                                staticClass: "field-tab-chat",
                                attrs: {
                                  lazy: _vm.lazyLoadChat,
                                  title: "Chat"
                                },
                                on: { click: _vm.turnOffLazy }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "chat-wrapper" },
                                  [
                                    _c("Chat", {
                                      attrs: {
                                        primaryParticipantId:
                                          _vm.projectDetail.id,
                                        primaryParticipantTitle:
                                          _vm.projectDetail.title,
                                        primaryParticipantType: 0,
                                        chatNamespace: "projectChat",
                                        shouldRefreshMessages:
                                          _vm.currentTab == 1
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: {
            open: _vm.showModalOptions,
            "calendar-controls": _vm.$router.currentRoute.name == "calendar"
          }
        },
        [
          _vm.userCanEditProject
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: "Delete Project" },
                  on: {
                    click: function($event) {
                      return _vm.removeProject()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$router.currentRoute.name == "calendar"
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn close-deliverable-btn",
                  attrs: { title: "Close" },
                  on: { click: _vm.onCloseModal }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveProject },
          model: {
            value: _vm.showRemoveProject,
            callback: function($$v) {
              _vm.showRemoveProject = $$v
            },
            expression: "showRemoveProject"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this project?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createProjectLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateProjectLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "project"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editProjectLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditProjectLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }